import React, { useCallback, useEffect, useState } from 'react'
import config from 'config'
import {
  button,
  text,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from 'ducks/currentUser/selectors'
import { styles } from './styles'

const hotjarConfig = config.hotjar

const SearchFeedback = () => {
  const currentUser = useSelector(selectCurrentUser)
  const [isReady, setIsReady] = useState(!!window.hj)
  const handleOpenSuggest = useCallback(
    () => {
      window.hj('identify', currentUser.id, {
        email: currentUser.email,
        name: `${currentUser.first_name} ${currentUser.last_name}`,
      })
      window.hj('event', 'search_feedback')
    },
    [currentUser]
  )

  useEffect(() => {
    const existing = document.getElementById('hotjar-script')
    if (existing) {
      return undefined
    }
    const handleLoad = () => {
      setIsReady(true)
    }
    const scriptTag = document.createElement('script')
    scriptTag.src = `https://static.hotjar.com/c/hotjar-${
      hotjarConfig.hjid
    }.js?sv=${hotjarConfig.hjsv}`
    scriptTag.id = 'hotjar-script'
    scriptTag.async = 'async'
    scriptTag.addEventListener('load', handleLoad)
    document.body.appendChild(scriptTag)

    return () => {
      scriptTag.removeEventListener('load', handleLoad)
    }
  }, [])

  if (!isReady || !currentUser.id || !window.hj) return null

  return (
    <button
      className="grui p-6 w-100 text-left"
      css={[button.styles.preflight, text.styles.fontSemibold, styles.button]}
      onClick={handleOpenSuggest}
      type="button"
    >
      <span className="grui mr-2">⚡️</span>Suggest an improvement for search
    </button>
  )
}

export default SearchFeedback
